.bk{flex:1;}